import React from "react";
import Container from "@/components/marketing/Container";
import { HELP_SECTIONS } from "@/lib/helpContent";

/**
 * Category card grid. Each card anchors to its section below via the
 * shared section id. Card click behaviour (clear search + smooth scroll)
 * is handled by the parent page.
 */
export default function HelpCategoryGrid({ onCategoryClick }) {
  return (
    <section className="pb-10 sm:pb-12 -mt-6 sm:-mt-10 lg:-mt-14 relative z-10">
      <Container className="max-w-5xl">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {HELP_SECTIONS.map((cat, idx) => (
            <button
              key={cat.id}
              type="button"
              onClick={() => onCategoryClick(cat.id)}
              className={`text-left bg-white border border-[#e8e6ef] rounded-xl p-5 shadow-md hover:border-cobalt/40 hover:-translate-y-0.5 hover:shadow-lg transition-all duration-200 cursor-pointer ${idx === 6 ? "lg:col-start-2" : ""}`}
            >
              <cat.icon className="w-5 h-5 text-cobalt mb-3" />
              <h3 className="font-heading text-[15px] font-semibold text-bone mb-1">{cat.title}</h3>
              <p className="text-sm text-steel leading-snug">{cat.desc}</p>
            </button>
          ))}
        </div>
      </Container>
    </section>
  );
}